import { IScreen } from 'src/components/user/user/types/screens-model';
import { IUserMetadata } from 'src/components/user/user/types/user-meta-model';

export default class Storage {
  static TOKEN_KEY = 'access';

  static REFRESH_TOKEN_KEY = 'refresh';

  static USER_METADATA_KEY = 'user_meta';

  static USER_SIMULATION_FLAG_KEY = 'enableSimulation';

  static USER_DELIST_SIMULATION_FLAG_KEY = 'enableDelistSimulation';

  static MODULE_ID_DATA = 'moduleIdData';

  static getToken() {
    return window.localStorage.getItem(Storage.TOKEN_KEY);
  }

  static setToken(token: string) {
    window.localStorage.setItem(Storage.TOKEN_KEY, token);
  }

  static getRefreshToken() {
    return window.localStorage.getItem(Storage.REFRESH_TOKEN_KEY);
  }

  static setRefreshToken(token: string) {
    window.localStorage.setItem(Storage.REFRESH_TOKEN_KEY, token);
  }

  static removeTokens() {
    window.localStorage.removeItem(Storage.REFRESH_TOKEN_KEY);
    window.localStorage.removeItem(Storage.TOKEN_KEY);
    window.localStorage.removeItem(Storage.USER_METADATA_KEY);
  }

  static setUserMetadata(data: {
    userMeta: IUserMetadata;
    screenMeta: IScreen[];
  }) {
    window.localStorage.setItem(
      Storage.USER_METADATA_KEY,
      window.btoa(JSON.stringify(data))
    );
  }

  static getUserMetadata(): { userMeta: IUserMetadata; screenMeta: IScreen[] } {
    const userMeta = window.localStorage.getItem(Storage.USER_METADATA_KEY);
    if (!userMeta) {
      return { screenMeta: null, userMeta: null };
    }
    const parsed = JSON.parse(window.atob(userMeta));
    if (!parsed.screenMeta) {
      window.localStorage.removeItem(Storage.USER_METADATA_KEY);
      return { screenMeta: null, userMeta: null };
    }
    return parsed;
  }

  static getSourceId() {
    return Storage.getUserMetadata() && Storage.getUserMetadata().userMeta
      ? Storage.getUserMetadata().userMeta
      : { source: null };
  }

  // handler for setting sourcr id
  static setSourceId(source: number) {
    const userMetadataObject = Storage.getUserMetadata();
    userMetadataObject.userMeta.source = source;
    this.setUserMetadata(userMetadataObject);
  }

  static setSimulationResultFlag(
    simulationBody: {
      enableSimulation: boolean;
    },
    keyName = 'enableSimulation'
  ) {
    localStorage.setItem(keyName, JSON.stringify(simulationBody));
  }

  static getSimulationResultFlag(keyName = Storage.USER_SIMULATION_FLAG_KEY): {
    enableSimulation: boolean;
  } {
    const result = localStorage.getItem(keyName);
    if (!result) {
      return { enableSimulation: false };
    }
    return JSON.parse(result);
  }

  // setting and getting data for Module Id
  static setModuleIdData(moduleIdData) {
    localStorage.setItem(
      this.MODULE_ID_DATA,
      JSON.stringify(moduleIdData.payload.data)
    );
  }

  static getModuleIdData() {
    return localStorage.getItem(this.MODULE_ID_DATA);
  }

  // handler for setting ph recommendation status
  static setPhRecommendationStatus(phRecommendationStatus) {
    localStorage.setItem('isPhRecommended', phRecommendationStatus);
  }

  static getPhRecommendationStatus() {
    const isPhRecommendedStatus = localStorage.getItem('isPhRecommended');
    return isPhRecommendedStatus;
  }

  // hanlder for setting segment details
  static setSegmentDetails(segmentDetails) {
    localStorage.setItem(
      'segmentDetails',
      JSON.stringify(segmentDetails.payload)
    );
  }

  static getSegmentDetails() {
    const segmentDetails = localStorage.getItem('segmentDetails');
    return JSON.parse(segmentDetails);
  }

  // handler for setting search query
  static setSearchQuery(searchQuery) {
    localStorage.setItem('searchQuery', searchQuery);
  }

  static getSearchQuery() {
    const searchQuery = localStorage.getItem('searchQuery');
    return searchQuery;
  }

  // handler for setting ph recommendation legend object
  static setPhRecommendationLegend(phRecommendationLegend) {
    localStorage.setItem(
      'phRecommendationLegend',
      JSON.stringify(phRecommendationLegend)
    );
  }

  static getPhRecommendationLegend() {
    const phRecommendationLegend = JSON.parse(
      localStorage.getItem('phRecommendationLegend')
    )?.payload.ph_legend_map_object;
    return phRecommendationLegend;
  }
}
